export const lang = (state, getters, rootState) => {
  return state.choicelang
}
export const contents = (state, getters, rootState, rootGetters) => {
  let lang = localStorage.lang
  if (lang && lang !== 'null') {
    state.choicelang = lang
  } else {
    localStorage.lang = 0
    state.choicelang = 0
  }
  var data = {}
  state.contents.map(function (ele, index) {
    if (ele.id.toString() === state.choicelang.toString()) {
      data = state.contents[index]
    }
  })
  return data
}



// WEBPACK FOOTER //
// ./src/store/modules/getters.js